import { render, staticRenderFns } from "./ameli-banner.vue?vue&type=template&id=4b8b4adb&scoped=true"
import script from "./ameli-banner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ameli-banner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ameli-banner.vue?vue&type=style&index=0&id=4b8b4adb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b4adb",
  null
  
)

export default component.exports